export const isProd =
  process.env.NEXT_PUBLIC_DOMAIN === "carbonhealth.com" && process.env.NODE_ENV === "production";
